import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { z } from 'zod';
import { IconDeviceFloppy } from '@rossum/ui/icons/tabler';
import {
  Box,
  Button,
  Dialog,
  Stack,
  SvgIcon,
  Typography,
} from '@rossum/ui/material';
import TextFieldControl from '../../../../components/ReactHookForm/controls/TextFieldControl';

type FormModel = {
  name: string;
};

type Props = {
  defaultName: string;
  isOpen: boolean;
  onSubmit: (model: FormModel) => void;
  onCancel: () => void;
};

const NewTemplateNameModal = ({
  defaultName,
  isOpen,
  onSubmit,
  onCancel,
}: Props) => {
  const intl = useIntl();

  const validationSchema = z.object({
    name: z
      .string()
      .min(
        1,
        intl.formatMessage({ id: 'components.emailSent.modal.nameIsRequired' })
      ),
  });

  const { handleSubmit, control } = useForm({
    mode: 'onTouched',
    defaultValues: { name: defaultName },
    resolver: zodResolver(validationSchema),
  });

  return (
    <Dialog open={isOpen} onClose={() => onCancel()}>
      <Box margin={2} sx={{ width: '400px' }}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack spacing={2}>
            <Typography variant="h6">
              {intl.formatMessage({ id: 'components.emailSent.modal.title' })}
            </Typography>
            <TextFieldControl
              ControllerProps={{ control, name: 'name' }}
              label={intl.formatMessage({
                id: 'components.emailSent.modal.templateName',
              })}
              helperText={intl.formatMessage({
                id: 'components.emailSent.modal.canEditInQueueSettings',
              })}
              FieldLabelProps={{
                layout: 'floating',
              }}
            />
            <Stack spacing={1} direction="row" justifyContent="flex-end">
              <Button onClick={() => onCancel()} type="reset">
                {intl.formatMessage({
                  id: 'components.emailSent.modal.cancel',
                })}
              </Button>
              <Button
                type="submit"
                startIcon={
                  <SvgIcon fontSize="large">
                    <IconDeviceFloppy />
                  </SvgIcon>
                }
                data-cy="save-template-via-modal"
              >
                {intl.formatMessage({ id: 'components.emailSent.modal.save' })}
              </Button>
            </Stack>
          </Stack>
        </form>
      </Box>
    </Dialog>
  );
};

export { NewTemplateNameModal };
